import { Component } from 'react';
// Composants
import { Button, Modal, TransitionablePortal } from 'semantic-ui-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SubscriptionRightList from '../Lists/SubscriptionRightList';
// Librairies
import { connect } from 'react-redux';
import i18n from '../../locales/i18n';
import { isMobile, isMobileOnly } from 'react-device-detect';
import { faCalendarCheck, faCircleDollar, faLock } from '@fortawesome/pro-solid-svg-icons';
// Utils
import StylesUtil from '../../utils/StylesUtil';

class ProFeaturesButton extends Component {
    state = {
        isOpen: false
    };

    render() {
        const { isOpen } = this.state;
        const { feature, buttonId, showButton, style, project, activeOrganization } = this.props;
        const projectSubscription = project?.organization?.subscription;
        const userSubscription = activeOrganization?.subscription;
        const isEnabled = (!projectSubscription || projectSubscription[feature]) && userSubscription?.[feature];
        const { modalMobileStyle } = StylesUtil.getMapStyles();

        return (
            <>
                {!isEnabled && showButton !== false &&
                    <Button id={buttonId} onClick={this.openModal} style={{ backgroundColor: 'transparent', padding: 0, margin: 0 }}>
                        <FontAwesomeIcon
                            icon={faLock} title={i18n.t("Upgradez votre licence pour débloquer cette fonctionnalité")}
                            style={{ fontSize: '10px', color: 'var(--yellow-100)', ...(style || {}) }}
                        />
                    </Button>
                }
                <TransitionablePortal
                    open={isOpen}
                    transition={{ animation: 'fade up', duration: 300 }}
                    closeOnDocumentClick={false}
                >
                    <Modal
                        className='subscription-modal'
                        size='small' open onClose={this.closeModal} closeIcon={false}
                        style={isMobile ? modalMobileStyle : { maxHeight: '95vh' }}
                    >
                        <Modal.Header>
                            <FontAwesomeIcon icon={faCircleDollar} style={{ marginRight: '10px' }} />
                            {i18n.t("Passez à une offre supérieure")}
                        </Modal.Header>
                        <Modal.Content style={{ flex: 1, overflowY: 'auto' }}>
                            <p>{i18n.t("Cette fonctionnalité n'est pas disponible avec votre licence actuelle. Passez à une offre supérieure pour y accéder.")}</p>
                            <h3 style={{ margin: 0 }}>{i18n.t("Avantages de votre licence")}</h3>
                            <SubscriptionRightList renderProjects={false} renderUsers={false} renderElements={false} featuresToHighlight={[feature]} />
                        </Modal.Content>
                        <Modal.Actions style={isMobileOnly ? { display: 'flex' } : undefined}>
                            <Button color='grey' onClick={this.closeModal}>
                                {i18n.t("Fermer")}
                            </Button>
                            <Button
                                color='blue'
                                style={isMobileOnly ? { flex: 1 } : undefined}
                                onClick={(e) => {
                                    this.closeModal(e);
                                    window.open('https://grality.com/demande-de-demo', '_blank', 'noopener,noreferrer');
                                }}
                            >
                                <FontAwesomeIcon icon={faCalendarCheck} style={{ marginRight: '10px' }} />
                                {isMobileOnly ? i18n.t("Prendre rendez-vous") : i18n.t("Prendre rendez-vous avec l'équipe Grality")}
                            </Button>
                        </Modal.Actions>
                    </Modal>
                </TransitionablePortal>
            </>
        );
    }

    componentDidMount = () => {
        if (this.props.isDefaultOpen)
            this.openModal();
    }

    openModal = (e) => {
        const { feature } = this.props;

        e?.preventDefault();
        e?.stopPropagation();
        this.setState({ isOpen: true }, () => {
            if (feature)
                setTimeout(() => document.getElementById(`feature-${feature}`).scrollIntoView({ behavior: 'smooth' }), 500);
        });
    }

    closeModal = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (this.props.onClose) this.props.onClose();
        this.setState({ isOpen: false });
    }
}

const mapStateToProps = (state) => {
    return {
        project: state.project,
        activeOrganization: state.activeOrganization,
    };
};

export default connect(mapStateToProps)(ProFeaturesButton);